import { buildModelManager } from "../builder.js";
const DefaultComplianceCertificateSelection = {
  __typename: true,
  id: true,
  certificateNumber: true,
  certificateType: true,
  createdAt: true,
  deletedAt: true,
  documentUrl: true,
  expiryDate: true,
  issuedDate: true,
  notes: true,
  propertyId: true,
  status: true,
  updatedAt: true
};
const modelApiIdentifier = "complianceCertificate";
const pluralModelApiIdentifier = "complianceCertificates";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultComplianceCertificateSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultComplianceCertificateSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultComplianceCertificateSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultComplianceCertificateSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultComplianceCertificateSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultComplianceCertificateSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultComplianceCertificateSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createComplianceCertificate",
    operationReturnType: "CreateComplianceCertificate",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      complianceCertificate: { required: false, type: "CreateComplianceCertificateInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultComplianceCertificateSelection
  },
  {
    type: "action",
    operationName: "bulkCreateComplianceCertificates",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateComplianceCertificatesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultComplianceCertificateSelection
  },
  {
    type: "action",
    operationName: "updateComplianceCertificate",
    operationReturnType: "UpdateComplianceCertificate",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      complianceCertificate: { required: false, type: "UpdateComplianceCertificateInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultComplianceCertificateSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateComplianceCertificates",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateComplianceCertificatesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultComplianceCertificateSelection
  },
  {
    type: "action",
    operationName: "deleteComplianceCertificate",
    operationReturnType: "DeleteComplianceCertificate",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteComplianceCertificates",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "restoreComplianceCertificate",
    operationReturnType: "RestoreComplianceCertificate",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      complianceCertificate: { required: false, type: "RestoreComplianceCertificateInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultComplianceCertificateSelection
  },
  {
    type: "action",
    operationName: "bulkRestoreComplianceCertificates",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkRestoreComplianceCertificatesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultComplianceCertificateSelection
  },
  {
    type: "action",
    operationName: "upsertComplianceCertificate",
    operationReturnType: "UpsertComplianceCertificate",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      complianceCertificate: { required: false, type: "UpsertComplianceCertificateInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateComplianceCertificateResult": { hasReturnType: false },
      "... on UpdateComplianceCertificateResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultComplianceCertificateSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertComplianceCertificates",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertComplianceCertificatesInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultComplianceCertificateSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "complianceCertificateGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ComplianceCertificateManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultComplianceCertificateSelection,
  operations
);
export {
  ComplianceCertificateManager,
  DefaultComplianceCertificateSelection
};
//# sourceMappingURL=ComplianceCertificate.js.map
